import React, { memo } from 'react';
import { t } from 'Src/i18n';
import { Image } from 'Components/frameworks/image/Image';
import { useGQL } from 'Utils/graphql-client/use-gql/useGQL';
import { useGQLErrorsHandler } from 'Utils/use-gql-errors-handler/useGQLErrorsHandler';
type Props = {
  productId: string;
};

const tripadvisorQuery = (productId: string) => `query {
    tripadvisor(productId : "${productId}") {
            numReviews
            rating
            ratingImageUrl
        }
}`;

export const TripadvisorProductCard = memo<Props>(({ productId }: Props) => {
  const { data, error, isLoading } = useGQL({
    query: tripadvisorQuery(productId),
    queryOptions: {
      cacheFront: {
        key: `PRODUCT_GET_TRIPADVISOR_${productId}`,
      },
      requestName: 'PRODUCT_GET_TRIPADVISOR',
    },
    cache: true,
    ignore: !productId,
    map: ({ tripadvisor }) => ({
      ...tripadvisor,
      hasTripadvisor: Boolean(
        tripadvisor.numReviews && tripadvisor.rating && tripadvisor.ratingImageUrl,
      ),
    }),
  });
  useGQLErrorsHandler(error, {
    catchAuthError: true,
  });

  if (!data || error || isLoading) {
    return null;
  }

  return (
    data?.hasTripadvisor && (
      <div className="-ml-5 mt-10 flex text-14 font-bold leading-tight text-black">
        <Image
          altMsg={data?.rating}
          classNameImg="w-[6rem]"
          dontChangeAnything
          imageUrl={data?.ratingImageUrl}
          ratioDisplay={3 / 20}
        />
        <span>{`${data?.numReviews} ${t('common.reviews').toLowerCase()}`}</span>
      </div>
    )
  );
});
